import LocationAdapter from './location_adapter';
import URLUtils from '../utils/url_utils';

export default class PubmaticAdapter {
  static appendOpenWrapTargeting(tag, adUnit, adSize, callback){
    var pubmaticUrl = PubmaticAdapter.getPubmaticURL(adUnit, adSize);

    var xhr = new XMLHttpRequest();
    xhr.timeout = 1000;
    xhr.withCredentials = true;
    xhr.open("GET", pubmaticUrl);
    xhr.onload = function() {
      var appendedTag = tag;
      if(xhr.status == 200) {
        appendedTag = PubmaticAdapter.openWrapRequestSuccess(tag, xhr.response);
      }

      callback(appendedTag);
    }.bind(this);

    xhr.ontimeout = function() {
      callback(tag);
    }

    xhr.onerror = function() {
      callback(tag);
    }

    xhr.send();
  }

  static getPubmaticURL(adUnit, adSize) {
    var currentLocation = LocationAdapter.href();
    if(currentLocation.includes("localhost") || currentLocation.includes("127.0.0.1")) {
      return "http://localhost:9898/ads_params/pubmatic/1"
    }
    else {
      var encodedAdUnit = encodeURIComponent(adUnit);
      var encodedLocation = encodeURIComponent(currentLocation);
      var url = "https://ow.pubmatic.com/openrtb/2.5/video";
      var owUrl = new URL(url);
      var params = "";

      // refer to this document for these parameters https://docs.google.com/spreadsheets/d/1gpaGyyorUAjubpmlpGm7qrUVDLsXSs_b6mRtPaeuleo/edit?usp=drive_web&ouid=102762846474233040381
      params = params + "pubId=159568";
      params = params + "&profId=2803";
      params = params + "&adserver=DFP";
      params = params + "&pwtplt=video";
      params = params + "&pwtmime=1,6";
      params = params + "&f=json";
      params = params + "&pwtm_iu=" + encodedAdUnit;
      params = params + "&pwtm_sz=" + adSize;
      params = params + "&pwtm_url=" + encodedLocation;
      params = params + "&pwtlmt=0";
      params = params + "&pwtdnt=0";
      params = params + "&pwtvapi=2,7";
      params = params + "&pwtvsz=" + adSize;
      params = params + "&pwtvlin=1";
      params = params + "&pwtmnbr=400";
      params = params + "&pwtmxbr=3000";
      params = params + "&pwtvmnd=6";
      params = params + "&pwtvmxd=300";
      params = params + "&pwtplbk=2";
      params = params + "&pwtprots=2,3,5,6,7,8";
      params = params + "&pwtskp=1";
      params = params + "&pwtskmn=15";
      params = params + "&pwtskat=5";
      params = params + "&pwtdly=0";

      if(window.kmklabs && window.kmklabs.ads) {
        var genre = window.kmklabs.ads.genre;
        var title = window.kmklabs.ads.film_name + " " + window.kmklabs.ads.title;
        title = title.trim();

        params = params + "&pwtgenre=" + genre;
        params = params + "&pwttitle=" + encodeURIComponent(title);

        var dctrValue = 'title=' + title + '|genre=' + genre;
        var encodedDctrValue = encodeURIComponent(dctrValue);
        var splittedGenre = genre.split(",");
        var mappedGenre = splittedGenre.map(function(it) {
          return '"' + it + '"';
        });
        var joinedGenre = mappedGenre.join();

        var bidRequestParameter = '{"pubmatic":{"keywords":[{"key":"title","value":["' + title + '"]},{"key":"genre","value":[' + joinedGenre + ']},{"key":"dctr","value":["'+ encodedDctrValue + '"]}]}}';
        var encodedBidRequestParameter = encodeURIComponent(bidRequestParameter);
        params = params + "&pwtbidrprm=" + encodedBidRequestParameter;
      }

      owUrl.search = params;

      return owUrl.toString();
    }
  }

  static openWrapRequestSuccess(tag, response) {
    var appendedTag = tag;
    try {
      var jsonResponse = JSON.parse(response)

      if(jsonResponse.targeting) {
        var custParams = URLUtils.getQueryParam(tag, "cust_params");
        var parsingResult = "";

        for(var targetingKey in jsonResponse.targeting) {
          parsingResult += `${targetingKey}=${jsonResponse.targeting[targetingKey]}&`;
        }

        parsingResult = parsingResult.replace(/&$/, "");

        if(custParams) {
          custParams = custParams + "&" + parsingResult;
        }
        else {
          custParams = parsingResult;
        }

        appendedTag = URLUtils.addQueryParam(tag, "cust_params", encodeURIComponent(custParams));
      }
    }
    catch (e) {
    }

    return appendedTag;
  }
}
